<template>
  <b-form-group
    label="Buton Bağlantı"
    label-for="url"
  >
    <b-form-input
      id="url"
      v-model="itemData.url"
      placeholder="Buton Bağlantı"
    />
  </b-form-group>
</template>

<script>
import { BFormGroup, BFormInput } from 'bootstrap-vue'

export default {
  name: 'ButtonUrl',
  components: { BFormInput, BFormGroup },
  computed: {
    itemData() {
      return this.$store.getters['carousel/dataItem']
    },
  },
}
</script>
